import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    baseApiUrl: "https://api.id-photo-verify.com",
    // baseApiUrl: "http://nyasu.leqi.us:10020",
    navState: 0,
    colors: []
  },
  mutations: {
    setNavState(state, payload) {
      state.navState = payload;
    }
  },
  actions: {},
  modules: {}
});
